import myu from "../images/myu.png";

// import hhh from '../images/HHH.png';
const teamOptions = ["Harmony", "Heart", "Global", "myU", "Connect", "Sync"];
const teams = [
  {
    key: "myU",
    name: "ĐỘI MYU",
    bg: "from-blue-400 to-blue-700",
    text: "text-blue-900",
    icon: myu,
    captain: "Trần Huy Hoàng",
    doipho: "Nguyễn Đỗ Tùng",
    danhsachthanhvien: [
      "Khoa Công nghệ Thông tin",
      "Trường Trung Cấp Vạn Tường",
      "CLB ITC",
      "CLB Mật mã Di sản",
    ],
    slogan: "",
  },
  {
    key: "Harmony",
    name: "ĐỘI HARMONY",
    bg: "from-blue-400 to-blue-700",
    text: "text-blue-900",
    icon: myu,
    captain: "Nguyễn Thu Trang",
    doipho: "Nguyễn Thị Thu Trang",
    danhsachthanhvien: [
      "Khoa KHXH&NV",
      "CLB Tâm lý học",
      "CLB VED",
      "CLB Văn học Nghệ thuật",
      "CLB Hàn Quốc học",
      "CLB Đại sứ Văn Hiến",
      "CLB Thời Trang",
      "CLB Karatedo",
      "Cựu SV các khoa/đơn vị",
    ],
    slogan: "",
  },
  {
    key: "Sync",
    name: "ĐỘI SYNC",
    bg: "from-blue-400 to-blue-700",
    text: "text-blue-900",
    icon: myu,
    captain: "Trần Anh Dũng",
    doipho: "Vũ Thanh Long",
    danhsachthanhvien: [
      "Khoa Kinh tế - Quản trị",
      "Trường CĐ Âu Lạc Huế",
      "Viện Sau đại học",
      "CLB Thương mại điện tử",
      "CLB Doanh nhân bản lĩnh",
      "CLB Bóng rổ",
      "CLB Võ thuật tổng hợp MMA",
      "Cựu SV các khoa/đơn vị",   

    ],
    slogan: "",
  },
  {
    key: "Global",
    name: "ĐỘI GLOBAL",
    bg: "from-blue-400 to-blue-700",
    text: "text-blue-900",
    icon: myu,
    captain: "Nguyễn Hoàng Quân",
    doipho: "Nguyễn Thị Diễm Tuyết",
    danhsachthanhvien: [
      "Khoa Y dược",
      "Khoa Du lịch",
      "Trường Trung cấp Vạn Hạnh",
      "CLB Sức khỏe Y học",
      "CLB Lữ Hành",
      "CLB Bartender",
      "CLB Công tác Xã hội",
      "CLB Văn nghệ",
      "CLB Bóng đá",
      "Cựu SV các khoa/đơn vị",
    ],
    slogan: "",
  },
  {
    key: "Connect",
    name: "ĐỘI CONNECT",
    bg: "from-blue-400 to-blue-700",
    text: "text-blue-900",
    icon: myu,
    captain: "Nguyễn Trọng Nghĩa",
    doipho: "Lê Sĩ Hải",
    danhsachthanhvien: [
      "Khoa Kỹ thuật - Công nghệ",
      "Trường Cao đẳng Bình Minh Sài Gòn",
      "Khoa Ngoại ngữ",
      "Viện Quốc tế",
      "CLB Kỹ thuật - Công nghệ",
      "CLB Tiếng Anh",
      "CLB Tiếng Trung",
      "CLB Nhật Bản học",
      "CLB Thư pháp",
      "CLB Truyền thông & Sự kiện",
      "CLB Vovinam",
      "CLB Thể thao điện tử",
      "Cựu SV các khoa/đơn vị"
    ],
    slogan: "",
  },
  {
    key: "Heart",
    name: "ĐỘI HEART",
    bg: "from-blue-400 to-blue-700",
    text: "text-blue-900",
    icon: myu,
    captain: "Trần Huy Hoàng",
    doipho: "Nguyễn Đỗ Tùng",
    danhsachthanhvien: [
      "Khoa Nghệ thuật",
      "Khoa Kế toán – Tài chính",
      "CLB Luật học",
      "CLB Tài chính – Kế toán",
      "CLB Kỹ năng",
      "CLB Guitar",
      "CLB Bóng chuyền",
      "Cựu SV các khoa/đơn vị"
    ],
    slogan: "",
  },
];

export default teams;
